import {
    HTTP
} from '@/utilities/http-common';
import _ from "lodash";

export default {
    namespaced: true,
    state: {
        user: {},
        myGroups: []
    },
    getters: {
        inMyGroups: (state) => (groups) => {
            return Boolean((_.intersection(state.myGroups, groups)).length);
        }
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
            window.localStorage.setItem('user', JSON.stringify(state.user));
        },
        setMyGroups(state, groups) {
            state.myGroups = groups;
            window.localStorage.setItem('groups', JSON.stringify(state.myGroups));
        },
        setMyGroupsFromLocalStorage(state, groups) {
            state.myGroups = groups;
        },
        setUserFromLocalStorage(state, user) {
            state.user = user;
        }
    },
    actions: {
        setUser({ commit }, user) {
            commit('setUser', user);
        },
        getUser() {
            return HTTP.get('/users/api/me/');
        },
        getMyGroups() {
            return HTTP.get('/users/api/user-groups/');
        },
        setMyGroups({ commit }, groups) {
            commit('setMyGroups', groups);
        },
        initUser({commit}) {
            const user = window.localStorage.getItem('user');
            if(user) {
                commit('setUserFromLocalStorage', JSON.parse(user));
            }
        },
        clearUser() {
            window.localStorage.removeItem('user');
            window.localStorage.removeItem('groups');
        },
        initMyGroups({ commit }) {
            let groups = window.localStorage.getItem('groups');
            if (groups) {
                commit('setMyGroupsFromLocalStorage', JSON.parse(groups));
            }
        },
    },
}